<template>
  <el-dialog :title="$t('printerMachine.add')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="addPrinterMachineInfo" label-width="120px" label-position="left">
      <el-form-item :label="$t('printerMachine.machineCode')" prop="machineCode" :rules="[
        { required: true, message: $t('printerMachine.machineCodeRequired'), trigger: 'blur' },
        { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
      ]">
        <el-input v-model="addPrinterMachineInfo.machineCode" :placeholder="$t('printerMachine.machineCodePlaceholder')"
          style="width: 100%"></el-input>
      </el-form-item>

      <el-form-item :label="$t('printerMachine.machineType')" prop="machineType" :rules="[
        { required: true, message: $t('printerMachine.machineTypeRequired'), trigger: 'change' },
        { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
      ]">
        <el-select v-model="addPrinterMachineInfo.machineType"
          :placeholder="$t('printerMachine.machineTypePlaceholder')" style="width: 100%">
          <el-option :label="$t('printerMachine.orderPrinter')" value="ORDER"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('printerMachine.appId')" prop="appId" :rules="[
        { required: true, message: $t('printerMachine.appIdRequired'), trigger: 'blur' },
        { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
      ]">
        <el-input v-model="addPrinterMachineInfo.appId" :placeholder="$t('printerMachine.appIdPlaceholder')"
          style="width: 100%"></el-input>
      </el-form-item>

      <el-form-item :label="$t('printerMachine.appSecure')" prop="appSecure" :rules="[
        { required: true, message: $t('printerMachine.appSecureRequired'), trigger: 'blur' },
        { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
      ]">
        <el-input v-model="addPrinterMachineInfo.appSecure" :placeholder="$t('printerMachine.appSecurePlaceholder')"
          style="width: 100%"></el-input>
      </el-form-item>

      <el-form-item :label="$t('printerMachine.machineImpl')" prop="machineImpl" :rules="[
        { required: true, message: $t('printerMachine.machineImplRequired'), trigger: 'change' }
      ]">
        <el-select v-model="addPrinterMachineInfo.machineImpl"
          :placeholder="$t('printerMachine.machineImplPlaceholder')" style="width: 100%">
          <el-option :label="$t('printerMachine.yilanyun')" value="yilanyunOrderPrintAdapter"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveShopPrinterMachineInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveShopPrinterMachine } from '@/api/shop/printerMachineApi'

export default {
  name: 'AddPrinterMachine',
  data() {
    return {
      dialogVisible: false,
      addPrinterMachineInfo: {
        machineCode: '',
        machineType: '',
        appId: '',
        appSecure: '',
        shopId: '',
        machineImpl: ''
      }
    }
  },
  methods: {
    open(params) {
      this.addPrinterMachineInfo.shopId = params.shopId
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async saveShopPrinterMachineInfo() {
      try {
        await this.$refs.form.validate()
        await saveShopPrinterMachine(this.addPrinterMachineInfo)
        this.$message.success(this.$t('printerMachine.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>